var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgainstVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4964da;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_920777_cc",
    transform: "translate(-23.5 -23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    transform: "translate(23.5 23.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    className: "cls-1",
    width: 8.853,
    height: 1.283,
    transform: "translate(0 2.181)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    className: "cls-1",
    width: 4.458,
    height: 1.283,
    transform: "translate(0 13.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    className: "cls-1",
    d: "M27.317,46.845H28.6V41.2H27.317v2.181H23.5v1.283h3.817Z",
    transform: "translate(-23.5 -35.523)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    className: "cls-1",
    width: 9.334,
    height: 1.283,
    transform: "translate(7.666 7.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-1",
    d: "M55.375,61.013H46.683V58.8H45.4v5.677h1.283V62.3h8.692Z",
    transform: "translate(-38.375 -47.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-1",
    d: "M60.383,26.964h4.3V25.681h-4.3V23.5H59.1v5.677h1.283Z",
    transform: "translate(-47.681 -23.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgainstVoucher);
export default __webpack_public_path__ + "static/media/against_voucher.629e238e3520db2eaa0b1a90204ae526.svg";
export { ForwardRef as ReactComponent };